var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2DownloadFromCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 58h9L38 69.93 27 58h9V27h4v31zm15.15-35.08h-1.78a15.3 15.3 0 00-4.68-9 15.56 15.56 0 00-26 9h-1.84a11.5 11.5 0 100 23H30v-3.84h-9.15a7.67 7.67 0 110-15.33h5.41v-1.86a11.72 11.72 0 0119.75-8.18 11.539 11.539 0 013.63 8.17v1.87h5.41a7.669 7.669 0 110 15.33H46v3.84h9.15a11.5 11.5 0 100-23z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Download_from_cloud.0b59514c.svg";
export { SvgJ2DownloadFromCloud as ReactComponent };